import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
import { convertToCatalogDecimal, convertFromCatalogDecimal } from '@square/dashboard-items-data/utils/catalog-decimal-transform';
import { isPresent } from '@ember/utils';
const QUANTITY_FIELDS = ['quantity_equals_to', 'quantity_less_than', 'quantity_greater_than'];
export default ItemsV3Serializer.extend({
  attrs: {
    items: {
      serialize: 'ids',
      deserialize: 'ids'
    }
  },
  keyForRelationship(key, type) {
    if (key === 'tax') {
      return 'fee_id';
    } else if (key === 'diningOptions') {
      return 'dining_option_id';
    } else if (key === 'items') {
      return 'item_id';
    } else if (key === 'adjustmentTax') {
      return 'adjustment_fee_token';
    }
    return this._super(key, type);
  },
  serialize(snapshot) {
    const json = this._super(snapshot, {
      includeId: true
    });

    // Multiply quantity fields to the max precision allowed for decimal type attributes
    QUANTITY_FIELDS.forEach(key => {
      if (isPresent(json[key])) {
        json[key] = convertToCatalogDecimal(json[key]);
      }
    });
    return json;
  },
  normalize(type, object) {
    QUANTITY_FIELDS.forEach(key => {
      if (isPresent(object[key])) {
        object[key] = convertFromCatalogDecimal(object[key]);
      }
    });
    return this._super(type, object);
  }
});